import React from "react";
import {Typography} from "@mui/material";
import {StatusDot, Tone} from "../../../../components/kit";

/** Lo propio de las entrevistas (#13808); lo común está en el kit (#13877). */

export {avatarColor, btnSx, fullName, initials, panelSx, relative, SoftChip, toneColor} from "../../../../components/kit";
export type {Tone} from "../../../../components/kit";

export const SIGNAL_TONE: Record<string, Tone> = {GREEN: "success", AMBER: "warning", RED: "error", LOW: "success", MEDIUM: "warning", HIGH: "error"};

/** Salud o riesgo: punto de color y texto. Sin valor, un guion. */
export const Signal = ({value, labels}: { value?: string | null, labels: Record<string, string> }) => value
	? <StatusDot tone={SIGNAL_TONE[value] || "neutral"} label={labels[value] || value}/>
	: <Typography variant="body2" color="text.disabled">—</Typography>;
